module.exports = "<ul class=\"tab-navigation\">\n\t<li *ngFor=\"let tab of tabHeader\"  [routerLink]=\"tab.routerLink\" routerLinkActive=\"active\">\n\t\t<a class=\"tab-navigation__link\"  >{{tab.title}}</a>\n\t</li>\n</ul>\n<ng-content></ng-content>"


//////////////////
// WEBPACK FOOTER
// ./src/app/ui-helper/routing-tabs/tabbar.html
// module id = NM7v
// module chunks = 12